import "./accreditations.scss";
import altovaPartner from "../../assets/images/altova/logos/altovaPartner.gif";
import altovaPartnerConsult from "../../assets/images/altova/logos/altovaPartnerConsult.gif";
import awsProfessional from "../../assets/images/aws-professional.png";
import awsDevops from "../../assets/images/aws-devops.png";
import scrum from "../../assets/images/scrum.png";


function Accreditations(props) {

    return (
        <div class="accreditation">
            <h3 class="accreditation--header green-to-red-gradient-font">Accreditations:</h3>
            <div class="accreditation--content--left">
                <img src={awsProfessional} alt="Our team are AWS Professional Certified Solutions  Architects" hspace="20" height="100" />
                <img src={awsDevops} alt="Our team are AWS Devops Specialty Certified" hspace="20" height="100" />
                <img src={altovaPartner} alt="Altova Training Partner" hspace="20" />
                <img src={altovaPartnerConsult} alt="Altova Consulting Partner" hspace="20" />
                <img src={scrum} alt="Our team members are Professional Scrum master certified" hspace="20" height="100" />
            </div>
            <div class="accreditation--content--right">
                Website Design by tinyBox Creative
            </div>
        </div>
    );
}

export default Accreditations;